if (!customElements.get('video-hero')) {
  class VideoHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-video-hero-media]');
      this.toggle = this.querySelector('[data-video-hero-toggle]');

      if (!this.video || this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.video.addEventListener('playing', () => {
        this.classList.add('is-video-ready');
        this.updateControl();
      });
      this.video.addEventListener('pause', () => this.updateControl());
      this.video.addEventListener('error', () => this.classList.add('is-video-error'));
      this.toggle?.addEventListener('click', () => this.togglePlayback());

      if (this.reducedMotion.matches) {
        this.video.pause();
      } else if (this.dataset.autoplay === 'true') {
        this.playVideo();
      }

      this.updateControl();
    }

    playVideo() {
      const playPromise = this.video.play();
      if (playPromise) playPromise.catch(() => this.updateControl());
    }

    togglePlayback() {
      if (this.video.paused) {
        this.playVideo();
      } else {
        this.video.pause();
      }
    }

    updateControl() {
      if (!this.toggle) return;

      const isPaused = this.video.paused;
      this.toggle.dataset.state = isPaused ? 'paused' : 'playing';
      this.toggle.setAttribute('aria-label', isPaused ? 'Play background video' : 'Pause background video');
    }
  }

  customElements.define('video-hero', VideoHero);
}
